module.exports = __webpack_public_path__ + "static/media/industries-foundry-sand-s.f7244ea8.webp";